import { get } from 'lodash';

import { getZonesId } from 'State/controlInfo/selectors';

export const getTimeZones = state =>
  get(state, 'CommonState.timeZones.timeZones', []);

/**
 * Retrieves the user's timezone based on the ZonesId within controlinfo
 */
export const getUserTimeZone = state => {
  const timeZones = getTimeZones(state);
  return timeZones.find(tz => tz.Id === getZonesId(state));
};

export const getOffsetMinutes = state =>
  get(state, 'CommonState.timeZones.offsetMinutes.data');



// WEBPACK FOOTER //
// ./src/state/timeZones/selectors.js